import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _wrapNativeSuper from "@babel/runtime-corejs3/helpers/esm/wrapNativeSuper";
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import "regenerator-runtime/runtime";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
/* global ethereum */

import { reduce } from './async';
var Blockchain = {
  Contract: Contract,
  list: [],
  done: false,
  err: null
};
var contracts = [];

Blockchain.connect = function (options, callback) {
  var _this = this;

  var connect = function connect(_ref) {
    var dappConnection = _ref.dappConnection,
        _ref$dappAutoEnable = _ref.dappAutoEnable,
        dappAutoEnable = _ref$dappAutoEnable === void 0 ? true : _ref$dappAutoEnable,
        warnIfMetamask = _ref.warnIfMetamask,
        _ref$blockchainClient = _ref.blockchainClient,
        blockchainClient = _ref$blockchainClient === void 0 ? '' : _ref$blockchainClient;
    return new _Promise(function (resolve, reject) {
      _this.whenEnvIsLoaded(function () {
        _this.doFirst(function (done) {
          _this.autoEnable = dappAutoEnable;

          _this.doConnect(dappConnection, {
            warnAboutMetamask: warnIfMetamask,
            blockchainClient: blockchainClient
          }, function _callee(err) {
            var _err;

            return _regeneratorRuntime.async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _err = err;
                    _context.prev = 1;
                    _context.next = 4;
                    return _regeneratorRuntime.awrap(done(_err));

                  case 4:
                    _context.next = 9;
                    break;

                  case 6:
                    _context.prev = 6;
                    _context.t0 = _context["catch"](1);
                    _err = _context.t0;

                  case 9:
                    _context.prev = 9;

                    if (_err) {
                      reject(_err);
                    } else {
                      resolve();
                    }

                    return _context.finish(9);

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, null, null, [[1, 6, 9, 12]]);
          });
        });
      });
    });
  };

  if (callback) {
    connect(options).then(function (result) {
      callback(null, result);
    }).catch(callback);
    return;
  }

  return connect(options);
};

Blockchain.doFirst = function (todo) {
  var _this2 = this;

  todo(function (err) {
    var _context2;

    _this2.done = true;
    _this2.err = err;
    return _Promise.all(_mapInstanceProperty(_context2 = _this2.list).call(_context2, function (x) {
      return x(_this2.err);
    }));
  });
};

Blockchain.whenEnvIsLoaded = function (cb) {
  if (typeof document !== 'undefined' && document !== null && !/comp|inter|loaded/.test(document.readyState)) {
    document.addEventListener('DOMContentLoaded', cb);
  } else {
    cb();
  }
};

Blockchain.Providers = {};

Blockchain.registerProvider = function (providerName, obj) {
  this.Providers[providerName] = obj;
};

Blockchain.setProvider = function (providerName, options) {
  var provider = this.Providers[providerName];

  if (!provider) {
    if (providerName === 'web3') {
      console.log("the embarkjs-web3 package might be missing from your project dependencies");
    }

    throw new Error(['Unknown blockchain provider. Make sure to register it first using', 'EmbarkJS.Blockchain.registerProvider(providerName, providerObject)'].join(' '));
  }

  this.currentProviderName = providerName;
  this.blockchainConnector = provider;
  provider.init(options);
};

Blockchain.isAvailable = function () {
  if (!this.blockchainConnector) {
    return _Promise.resolve(false);
  }

  return this.blockchainConnector.getNetworkId().then(function (_) {
    return true;
  });
};

Blockchain.doConnect = function (connectionList, opts, doneCb) {
  var _this3 = this;

  var self = this;

  var checkConnect = function checkConnect(next) {
    var provider = self.blockchainConnector.getCurrentProvider();
    var connectionString = provider.host;

    _this3.blockchainConnector.getNetworkId().then(function (_id) {
      next(null, {
        connectionString: connectionString,
        error: null,
        connected: true
      });
    }).catch(function (error) {
      next(null, {
        connectionString: connectionString,
        error: error,
        connected: false
      });
    });
  };

  var connectWeb3 = function connectWeb3(next) {
    var connectionString;
    return _regeneratorRuntime.async(function connectWeb3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            connectionString = 'web3://';

            if (!(typeof window !== 'undefined' && window.ethereum)) {
              _context3.next = 13;
              break;
            }

            _context3.prev = 2;

            if (!Blockchain.autoEnable) {
              _context3.next = 6;
              break;
            }

            _context3.next = 6;
            return _regeneratorRuntime.awrap(ethereum.enable());

          case 6:
            _this3.blockchainConnector.setProvider(ethereum);

            return _context3.abrupt("return", checkConnect(next));

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", next(null, {
              connectionString: connectionString,
              error: _context3.t0,
              connected: false
            }));

          case 13:
            return _context3.abrupt("return", next(null, {
              connectionString: connectionString,
              error: new Error("web3 provider not detected"),
              connected: false
            }));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, [[2, 10]]);
  };

  var connectWebsocket = function connectWebsocket(value, next) {
    _this3.blockchainConnector.setProvider(_this3.blockchainConnector.getNewProvider('WebsocketProvider', value));

    checkConnect(next);
  };

  var connectHttp = function connectHttp(value, next) {
    _this3.blockchainConnector.setProvider(_this3.blockchainConnector.getNewProvider('HttpProvider', value));

    checkConnect(next);
  };

  var connectionErrs = {};
  reduce(connectionList, false, function (result, connectionString, next) {
    if (result.connected) {
      return next(null, result);
    } else if (result) {
      connectionErrs[result.connectionString] = result.error;
    }

    if (connectionString === '$WEB3') {
      connectWeb3(next);
    } else if (/^wss?:\/\//.test(connectionString)) {
      connectWebsocket(connectionString, next);
    } else {
      connectHttp(connectionString, next);
    }
  }, function _callee3(_err, result) {
    return _regeneratorRuntime.async(function _callee3$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!result.connected || result.error)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", doneCb(new BlockchainConnectionError(connectionErrs)));

          case 2:
            self.blockchainConnector.getAccounts(function _callee2(_err, accounts) {
              var currentProv;
              return _regeneratorRuntime.async(function _callee2$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      currentProv = self.blockchainConnector.getCurrentProvider();

                      if (opts.warnAboutMetamask) {
                        // if we are using metamask, ask embark to turn on dev_funds
                        // embark will only do this if geth is our client and we are in
                        // dev mode
                        if (opts.blockchainClient === 'geth') {
                          // TODO find a way to share the port number
                          console.warn("%cNote: There is a known issue with Geth (when in `--dev` mode) that may cause transactions to get stuck. To enable a workaround, start an Embark console (run command `embark console` in your terminal) or open the dashboard in Cockpit (http://localhost:55555), then type in the console command `devtxs on`. To disable the workaround, type `devtxs off` in the console.", "font-size: 2em");
                        }

                        if (currentProv && currentProv.isMetaMask || typeof window !== 'undefined' && window.ethereum && window.ethereum.isMetaMask) {
                          console.warn("%cNote: Embark has detected you are in the development environment and using Metamask, please make sure Metamask is connected to your local node", "font-size: 2em");

                          if (opts.blockchainClient === 'parity') {
                            console.warn("%cNote: Parity blocks the connection from browser extensions like Metamask. To resolve this problem, go to https://embark.status.im/docs/blockchain_configuration.html#Using-Parity-and-Metamask", "font-size: 2em");
                          }
                        }
                      }

                      if (accounts) {
                        self.blockchainConnector.setDefaultAccount(accounts[0]);
                      }

                      doneCb();

                    case 4:
                    case "end":
                      return _context4.stop();
                  }
                }
              });
            });

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    });
  });
}; // See https://eips.ethereum.org/EIPS/eip-1102


Blockchain.enableEthereum = function _callee4() {
  var _this4 = this;

  var accounts;
  return _regeneratorRuntime.async(function _callee4$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!(typeof window === 'undefined' || !window.ethereum)) {
            _context6.next = 2;
            break;
          }

          throw new Error('ethereum not available in this browser');

        case 2:
          _context6.next = 4;
          return _regeneratorRuntime.awrap(ethereum.enable());

        case 4:
          this.blockchainConnector.setProvider(ethereum);
          _context6.next = 7;
          return _regeneratorRuntime.awrap(this.blockchainConnector.getAccounts());

        case 7:
          accounts = _context6.sent;
          this.blockchainConnector.setDefaultAccount(accounts[0]);

          _forEachInstanceProperty(contracts).call(contracts, function (contract) {
            contract.options.from = _this4.blockchainConnector.getDefaultAccount();
          });

          return _context6.abrupt("return", accounts);

        case 11:
        case "end":
          return _context6.stop();
      }
    }
  }, null, this);
};

Blockchain.execWhenReady = function (cb) {
  if (this.done) {
    return cb(this.err, this.web3);
  }

  if (!this.list) {
    this.list = [];
  }

  this.list.push(cb);
};

function Contract(options) {
  var _context7;

  var self = this;
  var ContractClass;
  this.abi = options.abi || options.abiDefinition;
  this.address = options.address || options.deployedAddress;
  this.gas = options.gas;
  this.code = '0x' + options.code;
  this.blockchainConnector = Blockchain.blockchainConnector;
  ContractClass = this.blockchainConnector.newContract({
    abi: this.abi,
    address: this.address
  });
  contracts.push(ContractClass);
  ContractClass.options.data = this.code;
  var from = this.from || self.blockchainConnector.getDefaultAccount();

  if (from) {
    ContractClass.options.from = from;
  }

  ContractClass.abi = ContractClass.options.abi;
  ContractClass.address = this.address;
  ContractClass.gas = this.gas;
  ContractClass.bytecode = '0x' + options.code;
  ContractClass.runtime_bytecode = '0x' + options.runtime_bytecode;
  ContractClass.real_runtime_bytecode = '0x' + options.real_runtime_bytecode;

  var originalMethods = _Object$keys(ContractClass);

  Blockchain.execWhenReady(function () {
    if (!ContractClass.currentProvider) {
      ContractClass.setProvider(self.blockchainConnector.getCurrentProvider());
    }

    ContractClass.options.from = self.blockchainConnector.getDefaultAccount();
  });

  _forEachInstanceProperty(_context7 = ContractClass._jsonInterface).call(_context7, function (abi) {
    if (_indexOfInstanceProperty(originalMethods).call(originalMethods, abi.name) >= 0) {
      console.log(abi.name + " is a reserved word and cannot be used as a contract method, property or event");
      return;
    }

    if (!abi.inputs) {
      return;
    }

    var numExpectedInputs = abi.inputs.length;

    if (abi.type === 'function' && abi.constant) {
      ContractClass[abi.name] = function () {
        var _context8;

        var ref = ContractClass.methods[abi.name];
        var call = ref.apply.apply(ref, _concatInstanceProperty(_context8 = [ref]).call(_context8, _sliceInstanceProperty(Array.prototype).call(arguments))).call;
        return call.apply(call, []);
      };
    } else if (abi.type === 'function') {
      ContractClass[abi.name] = function () {
        var _context9;

        var options = {},
            cb = null,
            args = _sliceInstanceProperty(_context9 = _Array$from(arguments || [])).call(_context9, 0, numExpectedInputs);

        if (typeof arguments[numExpectedInputs] === 'function') {
          cb = arguments[numExpectedInputs];
        } else if (_typeof(arguments[numExpectedInputs]) === 'object') {
          options = arguments[numExpectedInputs];
          cb = arguments[numExpectedInputs + 1];
        }

        var ref = ContractClass.methods[abi.name];
        var send = ref.apply(ref, args).send;
        return send.apply(send, [options, cb]);
      };
    } else if (abi.type === 'event') {
      ContractClass[abi.name] = function (options, cb) {
        var ref = ContractClass.events[abi.name];
        return ref.apply(ref, [options, cb]);
      };
    }
  });

  return ContractClass;
}

Contract.prototype.deploy = function (args, _options) {
  var self = this;
  var contractParams;
  var options = _options || {};
  contractParams = args || [];
  contractParams.push({
    from: this.blockchainConnector.getDefaultAccount(),
    data: this.code,
    gas: options.gas || 800000
  });
  var contractObject = this.blockchainConnector.newContract({
    abi: this.abi
  });
  return new _Promise(function (resolve, reject) {
    contractParams.push(function (err, transaction) {
      if (err) {
        reject(err);
      } else if (transaction.address !== undefined) {
        resolve(new Contract({
          abi: self.abi,
          code: self.code,
          address: transaction.address
        }));
      }
    });
    contractObject["new"].apply(contractObject, contractParams);
  });
};

Contract.prototype.new = Contract.prototype.deploy;

Contract.prototype.at = function (address) {
  return new Contract({
    abi: this.abi,
    code: this.code,
    address: address
  });
};

Contract.prototype.send = function (value, unit, _options) {
  var options, wei;

  if (_typeof(unit) === 'object') {
    options = unit;
    wei = value;
  } else {
    options = _options || {};
    wei = this.blockchainConnector.toWei(value, unit);
  }

  options.to = this.address;
  options.value = wei;
  return this.blockchainConnector.send(options);
};

var BlockchainConnectionError =
/*#__PURE__*/
function (_Error) {
  _inherits(BlockchainConnectionError, _Error);

  function BlockchainConnectionError(connectionErrors) {
    var _this5;

    _classCallCheck(this, BlockchainConnectionError);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(BlockchainConnectionError).call(this, "Could not establish a connection to a node."));
    _this5.connections = connectionErrors;
    _this5.name = 'BlockchainConnectionError';
    return _this5;
  }

  return BlockchainConnectionError;
}(_wrapNativeSuper(Error));

export default Blockchain;